import { createSlice } from "@reduxjs/toolkit";

const initUserLogin = {
  id_user: null,
  role: null,
  email: null,
  nama_user: null,
  image_profile: null,
};

const initialState = {
  userLogin: initUserLogin,
};

export const GlobalSlice = createSlice({
  name: "Global",
  initialState,
  reducers: {
    resetUserLogin: (state) => {
      state.userLogin.id_user = null;
      state.userLogin.role = null;
      state.userLogin.email = null;
      state.userLogin.nama_user = null;
      state.userLogin.image_profile = null;
    },
    setUserLogin: (state, { payload }) => {
      state.userLogin.id_user = payload.id_user;
      state.userLogin.role = payload.role;
      state.userLogin.email = payload.email;
      state.userLogin.nama_user = payload.nama_user;
      state.userLogin.image_profile = payload.image_profile;
    },
  },
});

export const isLoggedIn = (userLogin) => userLogin.id_user !== null;

export const { resetUserLogin, setUserLogin } = GlobalSlice.actions;

export default GlobalSlice.reducer;
